<!--
  画面名：食材データ一覧画面
  画面概要：食材データの雛形を一覧表示する。
  備考：
-->
<!-- HTML -->
<template>
  <div>
    <FoodData
      :pageTitle ="$language.LabelFoodGroup"
      :isPlan="false"
    />
  </div>
</template>
<!-- /HTML -->

<script>
// 子（外部）コンポーネント読み込み
// 食材データ入力画面
import FoodData from '@/components/parts/common/FoodData'

export default {
  name: 'TemplateFoodData',
  // 使用コンポーネント
  components: {
    // 食材データ入力画面
    FoodData
  }
}
</script>
